(function () {
	function pad(value) {
		return String(value).padStart(2, '0');
	}

	// Accepts "YYYY-MM-DD" / "YYYY-MM-DD HH:MM" / the same with seconds,
	// and ISO strings with a UTC offset (+0300 / +03:00 / Z).
	function parseDate(value) {
		if (!value) return null;

		var normalized = value.trim().replace(' ', 'T');

		if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) {
			normalized += 'T00:00:00';
		} else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(normalized)) {
			normalized += ':00';
		}

		// Safari requires a colon in the timezone offset (+0300 -> +03:00).
		normalized = normalized.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');

		var date = new Date(normalized);

		if (Number.isNaN(date.getTime())) {
			date = new Date(value.trim().replace(/-/g, '/'));
		}

		return Number.isNaN(date.getTime()) ? null : date;
	}

	function initCountdownBar(section) {
		var bar = section.querySelector('[data-countdown-bar]');
		if (!bar || bar.dataset.initialized === 'true') return;

		bar.dataset.initialized = 'true';

		var endDate = parseDate(bar.dataset.endTime);
		var durationHours = parseFloat(bar.dataset.durationHours || '0');
		var restartOnExpired = bar.dataset.restartOnExpired === 'true';
		if (!endDate && durationHours > 0) {
			endDate = new Date(Date.now() + durationHours * 60 * 60 * 1000);
		}
		var expiredMessage = bar.dataset.expiredMessage || 'Oferta finalizada';
		var hideOnExpired = bar.dataset.hideOnExpired === 'true';
		var daysElement = bar.querySelector('[data-countdown-days]');
		var daysUnit = daysElement ? daysElement.closest('.countdown-bar__unit') : null;
		var hoursElement = bar.querySelector('[data-countdown-hours]');
		var minutesElement = bar.querySelector('[data-countdown-minutes]');
		var secondsElement = bar.querySelector('[data-countdown-seconds]');
		var expiredElement = bar.querySelector('[data-countdown-expired]');

		function updateHeight() {
			section.style.setProperty('--countdown-bar-height', bar.offsetHeight + 'px');
		}

		function expire() {
			if (restartOnExpired && durationHours > 0) {
				endDate = new Date(Date.now() + durationHours * 60 * 60 * 1000);
				return;
			}

			if (hideOnExpired) {
				section.classList.add('is-hidden');
				return;
			}

			bar.classList.add('is-expired');
			if (expiredElement) expiredElement.textContent = expiredMessage;
			updateHeight();
		}

		function tick() {
			if (!endDate) {
				expire();
				return;
			}

			var distance = endDate.getTime() - Date.now();
			if (distance <= 0) {
				clearInterval(interval);
				expire();
				return;
			}

			var days = Math.floor(distance / 86400000);
			var hours = Math.floor((distance % 86400000) / 3600000);
			var minutes = Math.floor((distance % 3600000) / 60000);
			var seconds = Math.floor((distance % 60000) / 1000);

			// Once there is less than a day left, drop the "Dias" unit.
			if (daysUnit) {
				daysUnit.classList.toggle('is-hidden', days === 0);
			}
			if (daysElement) daysElement.textContent = days;
			if (hoursElement) hoursElement.textContent = pad(hours);
			if (minutesElement) minutesElement.textContent = pad(minutes);
			if (secondsElement) secondsElement.textContent = pad(seconds);

			updateHeight();
		}

		var interval = setInterval(tick, 1000);
		tick();
		window.addEventListener('resize', updateHeight);
	}

	function initAll(root) {
		(root || document).querySelectorAll('[data-countdown-bar-section]').forEach(initCountdownBar);
	}

	document.addEventListener('DOMContentLoaded', function () {
		initAll(document);
	});

	document.addEventListener('shopify:section:load', function (event) {
		initAll(event.target);
	});
})();
